import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
import { useRequestState } from "./useRequestState";
var REQUEST_KEY = "deleteProductEntity";
export var useDeleteProductEntity = function () {
    var dispatch = useDispatch();
    var _a = useRequestState(REQUEST_KEY), data = _a.data, loading = _a.loading, error = _a.error;
    var deleteEntity = function (_a) {
        var id = _a.id, entity = _a.entity, userId = _a.userId;
        dispatch(customRequestApis({
            requestKey: REQUEST_KEY,
            method: "PATCH",
            path: "/asg/Api/V1/delete/".concat(entity, "/").concat(id, "/user-mod/").concat(userId),
            body: { force: true },
        }));
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(REQUEST_KEY));
        };
    }, []);
    return {
        deleteEntity: deleteEntity,
        entityDeleted: data,
        loading: loading,
        error: error,
        clearDeleted: function () { return dispatch(clearCustomRequest(REQUEST_KEY)); },
    };
};
